module.exports = __webpack_public_path__ + "img/bowel-cancer.042cd4d.png";